export default __webpack_public_path__ + "static/media/sliderImg1.095cf88a.jpg";